<template>
    <v-menu
        v-model="menu"
        :close-on-content-click="false"
        :disabled="disabled"
        max-width="30rem"
        :nudge-right="30"
        offset-y
    >
        <template #activator="{ on, attrs }">
            <div class="app-theme-colour" :class="{ 'elevation-2': !disabled }">
                <v-btn class="app-theme-colour__dot" :color="colour" ::depressed="disabled" v-bind="attrs" v-on="on" />
                <span class="app-theme-colour__label">{{ label }}</span>
                <app-contrast-check :colour="colour" :background="background ? background : '#ffffff'" class="ml-2" />
            </div>
        </template>

        <v-color-picker v-model="colour" mode="hexa" />
    </v-menu>
</template>

<script>
export default {
    name: 'AppThemeColour',
    components: {
        AppContrastCheck: () => import('./AppContrastCheck.vue')
    },
    props: {
        value: {
            type: String,
            default: '#000000'
        },
        background: {
            type: String,
            default: null
        },
        name: {
            type: String,
            default: null
        },
        label: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        warning: {
            type: String,
            default: null
        }
    },
    data: () => ({
        menu: false
    }),
    computed: {
        colour: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.app-theme-colour {
    display: table;
    padding: 0.4rem 0.6rem;
    border-radius: 10rem;
    border: 1px solid var(--v-background-darken3);
    &__dot {
        min-width: 1.5rem !important;
        width: 1.5rem !important;
        height: 1.5rem !important;
        padding: 0 !important;
        border-radius: 50%;
        border: 2px solid rgba(0, 0, 0, 0.06) !important;
    }
    &__label {
        font-size: 0.9rem;
        margin-left: 0.4rem;
    }
}
</style>
